"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationLayer_1 = require("./AnimationLayer");
var ImageLayer = (function (_super) {
    tslib_1.__extends(ImageLayer, _super);
    function ImageLayer(rawData, version) {
        return _super.call(this, rawData, version) || this;
    }
    Object.defineProperty(ImageLayer.prototype, "imageId", {
        get: function () {
            return this._rawData.refId;
        },
        set: function (imageId) {
            this._rawData.refId = imageId;
        },
        enumerable: true,
        configurable: true
    });
    return ImageLayer;
}(AnimationLayer_1.AnimationLayer));
exports.ImageLayer = ImageLayer;
//# sourceMappingURL=ImageLayer.js.map